import React, { ForwardedRef, forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { XMark } from "../../icons"
import { ESidepanel, SidepanelHandle, SidepanelProp } from "./TypeSidepanel"

export function SidepanelComponent(
    {
        position = ESidepanel.Right,
        open: _open = false,
        label = '',
        children,
    }: SidepanelProp,
    ref: ForwardedRef<SidepanelHandle>
) {

    let classes = position === ESidepanel.Right ?  'right-0' : 'left-0'
    const [open, setOpen] = useState(_open)

    useEffect(() => {
        setOpen(_open)
    }, [_open])

    classes += open ? ' translate-x-0' : ' translate-x-96'

    useImperativeHandle(ref, () => ({
        open: () => {
            setOpen(true)
        },
        close: () => {
            setOpen(false)
        },
        toggle: () => {
            setOpen(!open)
        }
    }))


    return (
        <div className={`h-[calc(100%-48px)] md:h-full w-96 duration-300 transition-all fixed top-[48px] md:top-0 sidepanel bg-white/95 backdrop-blur-xl dark:bg-color8 text-slate-700 dark:text-color3 shadow-pop ${classes}`}>
            <div className="flex h-16 pl-5 pr-3 mb-4 items-center gap-3 border-b border-line/80 dark:border-color7">
                <span className="w-2 h-2 rounded-full bg-gradient-to-br from-brand-500 to-fuchsia-500 shrink-0" />
                <div className="flex-1 text-ellipsis whitespace-nowrap overflow-hidden font-semibold text-[15px] tracking-[-0.01em] text-ink dark:text-white">{label}</div>
                <div className="cursor-pointer grid place-items-center w-9 h-9 rounded-full text-slate-400 hover:text-ink hover:bg-ink/[0.05] dark:hover:bg-color7 dark:hover:text-white transition-colors" onClick={() => setOpen(false)}><XMark className="w-5 h-5" /></div>
            </div>
            <div className="flex-1 flex flex-col overflow-auto scrollbar">
                {children}
            </div>
        </div>
    )
}

const Sidepanel = forwardRef<SidepanelHandle, SidepanelProp>(SidepanelComponent)
Sidepanel.displayName = "Sidepanel"

export { Sidepanel }